import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Globe, Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { Panel } from "../admin/fields";

export const usePlatform = () => useQuery({ queryKey: ["platform-settings"], queryFn: () => api.get("/platform/settings").then((r) => r.data) });

export const PlatformPanel = () => {
  const { data } = usePlatform();
  const [base, setBase] = useState("");
  const [busy, setBusy] = useState(false);
  const qc = useQueryClient();
  useEffect(() => {
    if (data) setBase(data.public_base);
  }, [data]);
  const save = async () => {
    setBusy(true);
    try {
      qc.setQueryData(["platform-settings"], (await api.put("/platform/settings", { public_base: base.trim().replace(/\/+$/, "") })).data);
      toast.success("Platform address saved");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Panel title="Platform address" hint="Once you connect your own domain to this app (Publish, Domain tab), enter it here. Booking links, embed codes and welcome emails will use it. Leave blank to use this app's address.">
      <div className="flex flex-wrap items-end gap-3">
        <label className="field min-w-[280px] flex-1"><span className="field-label">Address</span>
          <div className="relative">
            <Globe className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink/40" />
            <input className="field-input !pl-9 font-mono" placeholder="https://book.yourcompany.com" value={base} onChange={(e) => setBase(e.target.value)} data-testid="platform-base-input" />
          </div>
        </label>
        <button className="btn-primary" onClick={save} disabled={busy || !data} data-testid="platform-base-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />}Save</button>
      </div>
    </Panel>
  );
};
